var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell event-cell",class:[
       _vm.cell.prop,
       _vm.cell.propType,
     ]},[(_vm.entity.cameraType)?_c('CameraTypeIcon',{staticClass:"event-cell__icon",attrs:{"camera-type":_vm.entity.cameraType}}):_vm._e(),_c('div',{staticClass:"app-table__cell-content"},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }